import {QuestionImage} from 'common/models/survey';

import {QuestionMarkupItem} from '../QuestionMarkup/QuestionMarkup.types';

export enum QuestionLayoutType {
    Row = 'row',
    Column = 'column',
}

export interface QuestionLayoutProps {
    type: QuestionLayoutType;
    label?: string;
    comment?: string;
    image?: QuestionImage;
    control?: React.ReactNode;
    className: string;
    required: boolean;
    positions?: QuestionMarkupItem[];
    hint?: string;
    header?: boolean;
    id?: string;
    error?: string;
}
